export const cacheTypes = {
  CONVS_CACHE_DATA: "CONVS_CACHE_DATA",
};
